/**
 * @generated SignedSource<<7f76046e277d3590ee59e83c2d8f46c8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserUpdatePasswordDialog_user$data = {
  readonly id: string;
  readonly " $fragmentType": "UserUpdatePasswordDialog_user";
};
export type UserUpdatePasswordDialog_user$key = {
  readonly " $data"?: UserUpdatePasswordDialog_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserUpdatePasswordDialog_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserUpdatePasswordDialog_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "4c50762e699925b313ace71579d1e145";

export default node;
